import vueWrapper from "../../utils/vue-wrapper";
import storeBody from './store-body.vue';

export default () => {
  vueWrapper(storeBody, "vue-store-body", "#storeBodyData")
}